<template src="./addnotes.html"></template>
<script>
import { mapState } from "vuex";
import "jquery/dist/jquery.min.js";
import Endpoints from "@/config/ApiEndpoints.js";
import Axios from "axios";
import $ from "jquery";
import Swiper, { navigation } from "swiper";

export default {
  components: {},
  props: {
    RequestFor: String,
    ItemId: String / Number,
    Type: String / Number,
  },
  filters: {},
  data() {
    return {
      notes: {},
      ShowAddNotePopup: false,
      Notes: { title: "", notes: "" },
    };
  },
  mounted() {
    //this.GetNotesList();
  },
  methods: {
    NewNoteOpen() {
      this.ShowAddNotePopup = true;
    },
    SaveNotes() {
      $("#note_save_btn").html("Processing...");
      let formData = new FormData();
      formData.append("token", localStorage.getItem("token"));
      formData.append("title", this.Notes.title);
      formData.append("notes", this.Notes.notes);
      formData.append("item_id", this.ItemId);
      formData.append("type", this.Type);
      Axios.post(Endpoints.Notes.Create, formData).then((Response) => {
        $("#note_save_btn").html("Save");
        if (Response.data.success == true) {
          this.Notes.title = this.Notes.notes = "";
          this.ShowAddNotePopup = false;
          this.$parent.LoadNotesData();
          this.$swal(Response.data.message, "", "success").then(() => {});
        } else {
          this.$swal(Response.data.message, "", "error").then(() => {});
        }
      });
    },
  },
};
</script>
